export default function getTotal(slice: any, totalKey = 'total') {
  return (state: any) => state.getIn([slice, 'meta', totalKey], 0);
}
